import { BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import { useState, useEffect } from "react";
import Gateway  from './views/Gateway'
import HobbitHole from './views/HobbitHole'
import Itinerary from './views/Itinerary'
import FellowshipTracker from './views/FellowshipTracker'
import YourSteps from './views/YourSteps'
import SeeingStone from './views/SeeingStone'

import ProtectedRoute from './components/ProtectedRoute'

import { URL } from './components/constants'
import Navbar from './components/Navbar'

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${URL}/me`, {
      credentials: "include", // important to send the cookie
    })
      .then(res => {
        if (res.status === 200) setIsLoggedIn(true);
        else setIsLoggedIn(false);
      })
      .finally(() => setLoading(false));
  }, []);
  if (loading) return <div><Navbar /></div>;

  return (
    <Router>
      <Routes>
        {/* Redirect root to some default page */}
        <Route
          path="/"
          element={
            isLoggedIn
              ? <Navigate to="/hobbithole" replace />
              : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/login"
          element={<Gateway onLogin={() => setIsLoggedIn(true)} />}
        />
        <Route
          path="/hobbithole"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <HobbitHole />
            </ProtectedRoute>
          }
        />
        <Route
          path="/itinerary"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <Itinerary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/fellowship"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <FellowshipTracker />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mirror"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <SeeingStone />
            </ProtectedRoute>
          }
        />
        <Route
          path="/steps"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <YourSteps />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}